<template>
  <v-app>
    <div class="site-margin">
      <h1>DND Helper</h1>
      <div id="nav">
        <router-link to="/">Spells</router-link> |
        <router-link to="/equipment">Equipment</router-link> |
        <router-link to="/magic_items">Magic Items</router-link>
      </div>
      <router-view :spells="spells" :equipment="equipment" :magicItems="magicItems"/>
    </div>
  </v-app>
</template>


<script>
import spellData from './assets/spells.json'
import equipmentData from './assets/equipment.json'
import magicItemData from './assets/magic-items.json'
export default {
  data:() => ({
    spells: [],
    equipment: [],
    magicItems: []
  }),

  methods: {
    loadSpells: async function() {
      this.spells = spellData;
    },
    loadEquipment: async function() {
      this.equipment = equipmentData;
    },
    loadMagicalItems: async function() {
      this.magicItems = magicItemData;
    },
  },

  beforeMount: function() {
    this.loadSpells();
    this.loadEquipment();
    this.loadMagicalItems();
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav {
  text-align: center;
  padding: 30px;
  margin-bottom:30px;

  a {
    font-weight: bold;
    // color: #2c3e50;
    color:beige;
    font-size: large;

    &.router-link-exact-active {
      // color: #42b983;
      color:lightgreen;
      font-size: x-large;
    }
  }
}

.site-margin {
  margin-left: 10px;
  margin-right: 10px;
}

h1 {
  text-align: center;
  margin: 10px;
  color: beige;
}
</style>
